import styled from '@emotion/styled/macro';

export const Progress = styled.div`
    height: 100vh;
    width: 100vw;
    display: flex;
    flex-direction: column;
    align-items: center;
`;
